<template>
  <div>
  <van-swipe :autoplay="3000" >
    <van-swipe-item v-for="(image, index) in images" :key="index" >
      <img v-lazy="image" />
    </van-swipe-item>
  </van-swipe>
  <van-grid square>
    <van-grid-item :key="0" icon="friends-o" text="会员中心" to = '/user/userList' v-has="'SYS:ACCOUNT'" />
    <van-grid-item :key="4" icon="orders-o" text="订单管理" to = '/order/orderList' v-has="'ORDER:STAT'"/>
    <van-grid-item :key="5" icon="shopping-cart-o" text="采购管理" to = '/purchase/PurchaseList' v-has="'STAT:PURCHASE'"/>
    <van-grid-item :key="6" icon="cash-on-deliver" text="钱包管理" to = '/user/walletList' v-has="'CAPITAL:STAT'"/>
    <van-grid-item :key="7" icon="bag-o" text="店铺管理" to = '/user/storeList' v-has="'SYS:ACCOUNT:STORE'"/>
    <van-grid-item :key="8" icon="chart-trending-o" text="销售统计" to = '/stat/saleList' v-has="'SALE:FINANCE:STAT'"/>
    <van-grid-item :key="9" icon="goods-collect-o" text="一键调价" to = '/product/productAdjust' v-has="'SALE:FINANCE:STAT'" />
    <van-grid-item :key="10" icon="wap-home-o" text="库存管理" to = '/stock/stockList' v-has="'SYS:STOCK'" />
    <van-grid-item :key="10" icon="manager-o" text="供应商管理" to = '/supplier/supplierList' v-has="'SYS:PLATFORM:SUPPLIER'" />
    <van-grid-item :key="11" icon="shop-o" text="商品管理" to = '/product/productList' />
<!--    <van-grid-item :key="11" icon="logistics" text="进货管理" to = '/purchase/CentralizedPlan' v-has="'SYS:STOCK'"/>-->
  </van-grid>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: { },
  data () {
    return {
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg'
      ],
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      show: false,
      model: {}
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage () {
      this.$api.shop.getCarouselList().then((res) => {
        this.images = []
        res.data.forEach((item) => {
          this.images.push(item.path)
        })
      })
    },
    getAvatarView: function (avatar) {
      if (avatar && avatar.indexOf('http') !== -1) {
        return avatar
      } else {
        return this.url.imgerver + '/' + avatar
      }
    },
    handleEdit (row) {
      this.model = {}
      this.$refs.userDrawer.show = true
      this.model = Object.assign({}, row)
    },
    handleSubmit () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        const formData = {
          id: this.model.id,
          username: this.model.username,
          nickname: this.model.nickname,
          phone: this.model.phone,
          avatar: this.model.avatar,
          roleIds: this.model.roleIds
        }
        this.$api.user.updateUser(formData).then((res) => {
          if (res.success) {
            this.$toast.success(res.msg)
            this.$refs.userDrawer.show = false
          } else {
            this.$toast.fail(res.msg)
          }
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    handleClose () {
      this.$refs.pageList.onRefresh(20, false)
    }
  }
}
</script>

<style lang="less" scoped>

  .van-swipe img {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 342px;
    /*padding: 30px 60px;*/
    background-color: #39a9ed;
    pointer-events: none;
  }
</style>
